import React from 'react';
import { Button, createStyles, makeStyles, Theme } from '@material-ui/core';

type ButtonProps = {
    title: string;
    type: 'primary' | 'secundary' | 'white';
    job?: 'submit' | 'reset' | 'button' | undefined;
    onClick?: () => void;
    disabled?: boolean; // Add disabled prop
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        button: {
            width: '302px',
            height: '72px',
            borderRadius: '15px',
            padding: '10px 20px 10px 20px !important',
            '& .MuiButton-label': {
                fontSize: '20px',
                fontWeight: 'bolder',
                textTransform: 'capitalize',
            },
            // Custom color for disabled state
            '&.Mui-disabled': {
                opacity: 0.7,
            },
        },
        primary: {
            color: 'white',
            backgroundColor: '#00BBFF',

            '& .MuiButton-label': {
                color: 'white',
                transition: '300ms',
            },
            '&:hover': {
                backgroundColor: 'white',
                '& .MuiButton-label': {
                    color: '#00BBFF',
                },
            },
        },
        secundary: {
            backgroundColor: 'white',

            '& .MuiButton-label': {
                color: '#00BBFF',
            },
            '&:hover': {
                backgroundColor: '00BBFF',
                '& .MuiButton-label': {
                    color: '#00BBFF',
                },
            },
        },
        white: {
            backgroundColor: 'white',

            '& .MuiButton-label': {
                color: '#00BBFF',
            },
            '&:hover': {
                backgroundColor: '00BBFF',
                '& .MuiButton-label': {
                    color: '#00BBFF',
                },
            },
        },
    }),
);

const BigButton: React.FC<ButtonProps> = ({ title, type, job, onClick, disabled }: ButtonProps) => {
    const classes = useStyles();
    return (
        <Button
            onClick={onClick}
            className={`${classes.button} ${classes[type]}`}
            size="large"
            type={job}
            disabled={disabled} // Pass disabled prop to the Button component
        >
            {title}
        </Button>
    );
};

BigButton.defaultProps = {
    onClick: () => { },
    job: undefined,
    disabled: false,
};

export default BigButton;